import React, { useState, useEffect } from "react";
import ReusableModal from "../../AppPAges/ManageSettings/ReusableModal";
import PaymentPage from "./PaymentPage"; 
import { renderModuleIcon } from './moduleIcons';
import useApi from "../../../../utils/api-manager/Helper/useApi";
import  useFormattingUtils  from "../../../../context/useFormattingUtils";
const SubscriptionModal = ({ show, handleClose, modelData, width = "50%", height = "auto" }) => {
    const [loading, setLoading] = useState(false);
    const [selectedPriceDetail, setSelectedPriceDetail] = useState(null);
    const [featureData, setFeatureData] = useState(null);
    const [proceedToPayment, setProceedToPayment] = useState(false); 
  const {formatCurrency} = useFormattingUtils()
    useEffect(() => {
        if (show && modelData) {
            const feature = Array.isArray(modelData) ? modelData[0] : modelData;
            if (feature && feature.price_details && feature.price_details.length > 0) {
                setFeatureData(feature);
                const oneMonthPlan = feature.price_details.find(p => p.no_of_months === 1);
                setSelectedPriceDetail(oneMonthPlan || feature.price_details[0]);
            }
        }
    }, [show, modelData]);

    const handlePriceDetailChange = (e) => {
        const selectedId = e.target.value;
        const selected = featureData?.price_details?.find(item => item.id === selectedId);
        if (selected) {
            setSelectedPriceDetail(selected);
        }
    };

    const handlePayNowClick = () => {
        if (!selectedPriceDetail) return;
        setProceedToPayment(true); 
    };

    const selectedModule = {
        id: featureData?.id,
        name: featureData?.title,
        icon: featureData?.icon,
        // priceDetail: selectedPriceDetail,
           price_details: featureData?.price_details,
        priceMonthly: selectedPriceDetail?.total_price,
        priceYearly: selectedPriceDetail?.total_price
    };

    return (
        <ReusableModal
            show={show}
            handleClose={() => {
                setProceedToPayment(false); 
                handleClose();
            }}
            width="438px"
            height="440px"
        >
            {!proceedToPayment ? (
                <div style={{
                    padding: "24px",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    gap: "24px",
                    
                    textAlign: "center"
                }}>
                    {}
                    <div style={{ 
                        display: 'flex', 
                        justifyContent: 'center',
                        alignItems: 'center',
                        marginBottom: "8px",

                    }}>
                        {}
                        <div style={{ 
                            transform: "scale(2.875)", 
                            transformOrigin: "center" 
                        }}>
                            {featureData?.icon
                                ? <img src={featureData.icon} alt={featureData.title} style={{ width: 42, height: 42, objectFit: 'contain' }} />
                                : featureData?.title && renderModuleIcon(featureData.title)}
                        </div>
                    </div>

                    {}
                    <h3 style={{
                        fontSize: "22px",
                        fontWeight: 700,
                        
               marginTop:"10px",
               color:'#000000'
                    }}>
                        {featureData?.title || "Subscription Plan"}
                    </h3>

                    {}
                    <div style={{ width: "100%", display: "flex", justifyContent: "center" }}>
                        <select
                            value={selectedPriceDetail?.id || ""}
                            onChange={handlePriceDetailChange}
                            style={{
                                width: "100%",
                                maxWidth: '180px',
                                padding: "12px 16px",
                                borderRadius: "50px",
                                border: "1px solid #E8E8E8",
                                fontSize: "16px",
                                backgroundColor: "#ffffff",

                            }}
                        >
                            {featureData?.price_details?.map((price) => (
                                <option key={price.id} value={price.id}>
                                  {formatCurrency(parseFloat(price.total_price || 0).toFixed(2))}/{price.no_of_months} {price.no_of_months === 1 ? 'Month' : 'Months'}
                                </option>
                            ))}
                        </select>
                    </div>

                    {}
                    <div style={{ width: "100%", display: "flex", justifyContent: "center" }}>
                        <button
                            disabled={loading}
                            style={{
                                width: "163px",
                                height: "40px",
                                backgroundColor: "#0D532F",
                                color: "white",
                                border: "none",
                                borderRadius: "27px",
                                fontSize: "18px",
                                fontWeight: 700,
                                cursor: loading ? "not-allowed" : "pointer",
                                
                                opacity: loading ? 0.7 : 1,
                            }}
                            onClick={handlePayNowClick} 
                        >
                            {loading ? "Processing..." : "Pay Now"}
                        </button>
                    </div>
                </div>
            ) : (
                <div
                    style={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        backgroundColor: "rgba(0, 0, 0, 0.5)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        zIndex: 99999,
                        backdropFilter: "blur(2px)",
                    }}
                >
                    <div
                        style={{
                            position: "relative",
                            width: "100%",
                            maxWidth: "1680px",
                            height: "auto",
                            maxHeight: "100vh",
                            overflow: "auto",
                            borderRadius: "20px",
                            backgroundColor: "white",
                            boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
                        }}
                    >
                        <PaymentPage
                            inModal={true}
                            selectedModules={[selectedModule]}
                            propBillingCycle={selectedPriceDetail?.no_of_months === 1 ? "Monthly" : "Yearly"}
                            onComplete={() => {
                                setProceedToPayment(false); 
                                handleClose(); 
                            }}
                            onBack={() => {
                                setProceedToPayment(false); 
                            }}
                        />
                    </div>
                </div>
            )}
        </ReusableModal>
    );
};

export default SubscriptionModal;
